import type { AppelApi } from '../../api/client.js';
import { useActionBoite } from '../../api/boite-reception.js';
import { estApiError } from '../../api/errors.js';
import { useErreurFormulaire } from '../useErreurFormulaire.js';
import { useShellContext } from '../shell/context.js';
import { useTranslation } from 'react-i18next';
export function useGesteBoite<T, V>(action: (corps: V, appel: AppelApi) => Promise<T>) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation('regie');
  const erreur = useErreurFormulaire();
  const mutation = useActionBoite(galerieSlug, action);
  return {
    pending: mutation.isPending,
    erreur:
      estApiError(mutation.error) && mutation.error.status === 409
        ? t('boiteReception.conflit')
        : erreur.erreur,
    async executer(corps: V): Promise<T | undefined> {
      erreur.reinitialiser();
      try {
        return await mutation.mutateAsync(corps);
      } catch (cause) {
        erreur.appliquer(cause, []);
        return undefined;
      }
    },
  };
}
